import { createStore } from '@stencil/store';
import { ContactState } from '../types';

const { state, onChange, on, set, reset } = createStore<ContactState>({
  phoneInfo: undefined,
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
